import { render, staticRenderFns } from "./_Announcement.vue?vue&type=template&id=285718de"
import script from "./_Announcement.vue?vue&type=script&lang=js"
export * from "./_Announcement.vue?vue&type=script&lang=js"
import style0 from "./_Announcement.vue?vue&type=style&index=0&id=285718de&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports